import { getGlobalLogger } from '@zg-rentals/logger-base';

export function formatMetaData({
  listingId = null,
  context = '',
  path = '',
  stack = '',
}: {
  listingId?: string | null;
  context: string;
  stack?: string | undefined;
  path?: string;
}) {
  return {
    listingId,
    context,
    path,
    stack,
  };
}

export function logInternal({
  message,
  listingId,
  context,
  stack,
  type,
}: {
  message: string;
  listingId?: string | null;
  context: string;
  stack?: string | undefined;
  type?: string;
}) {
  const appLogger = getGlobalLogger('APP');

  const path = typeof window !== 'undefined' ? window.location.href : '';
  const meta = formatMetaData({ listingId, context, path, stack });

  switch (type) {
    case 'info':
      appLogger?.info(meta, message);
      break;
    case 'warn':
      appLogger?.warn(meta, message);
      break;
    case 'debug':
      appLogger?.debug(meta, message);
      break;
    case 'trace':
      appLogger?.trace(meta, message);
      break;
    default:
      break;
  }
}

export function logInfo({
  message,
  listingId,
  context,
  stack,
}: {
  message: string;
  listingId?: string;
  context: string;
  stack?: string | undefined;
  type?: string;
}) {
  logInternal({ message, listingId, context, stack, type: 'info' });
}

export function logWarn({
  message,
  listingId,
  context,
  stack,
}: {
  message: string;
  listingId?: string;
  context: string;
  stack: string | undefined;
  type?: string;
}) {
  logInternal({ message, listingId, context, stack, type: 'warn' });
}

export function logDebug({
  message,
  listingId,
  context,
  stack,
}: {
  message: string;
  listingId?: string;
  context: string;
  stack?: string | undefined;
  type?: string;
}) {
  logInternal({ message, listingId, context, stack, type: 'debug' });
}

export function logTrace({
  message,
  listingId,
  context,
  stack,
}: {
  message: string;
  listingId?: string;
  context: string;
  stack?: string | undefined;
  type?: string;
}) {
  logInternal({ message, listingId, context, stack, type: 'trace' });
}
